import { useCallback, useState } from 'react'

export const DRAFT_CHANGED_EVENT = 'mobileCfgDraftChanged'

export interface DraftData<T> {
  data: T
  savedAt: number
}

export function useDraft<T>(storageKey: string) {
  const readFromStorage = (): DraftData<T> | null => {
    try {
      const raw = localStorage.getItem(storageKey)
      if (!raw) return null

      return JSON.parse(raw) as DraftData<T>
    } catch {
      return null
    }
  }

  const [draft, setDraft] = useState<DraftData<T> | null>(readFromStorage)

  const saveDraft = useCallback(
    (data: T) => {
      const draftData: DraftData<T> = { data, savedAt: Date.now() }
      localStorage.setItem(storageKey, JSON.stringify(draftData))
      setDraft(draftData)
      window.dispatchEvent(new CustomEvent(DRAFT_CHANGED_EVENT))
    },
    [storageKey],
  )

  const clearDraft = useCallback(() => {
    localStorage.removeItem(storageKey)
    setDraft(null)
    window.dispatchEvent(new CustomEvent(DRAFT_CHANGED_EVENT))
  }, [storageKey])

  return {
    saveDraft,
    clearDraft,
    draft,
    hasDraft: !!draft,
  }
}
